import type { Locale, RegionRow } from '../types';
import { chrome } from '../i18n';
import { PanelTitle } from './PanelTitle';

interface Props {
  title: string;
  subtitle: string;
  headers: string[];
  rows: RegionRow[];
  locale: Locale;
  hasRecs: boolean;
  recHint: string;
}

export function RegionTable({ title, subtitle, headers, rows, locale, hasRecs, recHint }: Props): string {
  const statusLabels = chrome(locale).status;
  const head = headers.map((h) => `<th scope="col">${h}</th>`).join('');
  const body = rows
    .map((r) => {
      const cells = r.cells.map((c) => `<td>${c}</td>`).join('');
      return `
      <tr>
        <td><b>${r.name}</b></td>
        ${cells}
        <td><div class="idx-cell"><div class="bar-cell" role="presentation"><span style="width:${r.index}%"></span></div><b>${r.index}</b></div></td>
        <td><span class="pill ${r.status}">${statusLabels[r.status]}</span></td>
      </tr>`;
    })
    .join('');
  return `
  <div class="panel span7">
    ${PanelTitle('map', title, 'regions', hasRecs, recHint)}
    <div class="sub">${subtitle}</div>
    <table aria-label="${title}"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
  </div>`;
}
